import { lazy } from 'react';
import { Route, STATIC_PAGES_PATHS } from './types';
import { QUIZ_IDS } from '../config/funnels';

const SessionRules = lazy(
  () => import('src/funnels/common/pages/StaticPages/SessionRules'),
);
const SubscriptionTerms = lazy(
  () => import('src/funnels/common/pages/StaticPages/SubscriptionTerms'),
);
const ContactUs = lazy(
  () => import('src/funnels/common/pages/StaticPages/ContactUs'),
);
const PrivacyPolicy = lazy(
  () => import('src/funnels/common/pages/StaticPages/PrivacyPolicy'),
);
const TermsAndConditions = lazy(
  () => import('src/funnels/common/pages/StaticPages/TermsAndConditions'),
);

const Mt = lazy(() => import('../../pl-mt'));
const MtHp = lazy(() => import('../../pl-mt-hp'));
const MtNt = lazy(() => import('../../pl-mt-nt'));
const MtCs = lazy(() => import('../../pl-mt-cs'));

const ThreeInOneNt = lazy(() => import('../../pl-3in1-nt'));

const BrNt = lazy(() => import('../../pl-br-nt'));

const Ff1m = lazy(() => import('../../pl-ff-1m'));

export const STATIC_ROUTES: Route[] = [
  {
    path: `/${STATIC_PAGES_PATHS.SUPPORT}`,
    Component: ContactUs,
  },
  {
    path: `/${STATIC_PAGES_PATHS.SUBSCRIPTION_TERMS}`,
    Component: SubscriptionTerms,
  },
  {
    path: `/${STATIC_PAGES_PATHS.SESSION_RULES}`,
    Component: SessionRules,
  },
  {
    path: `/${STATIC_PAGES_PATHS.PRIVACY_POLICY}`,
    Component: PrivacyPolicy,
  },
  {
    path: `/${STATIC_PAGES_PATHS.TERMS_AND_CONDITIONS}`,
    Component: TermsAndConditions,
  },
];

export const FUNNEL_ROUTES: Route[] = [
  {
    path: `/m/${QUIZ_IDS.MT_NT}`,
    Component: MtNt,
  },
  {
    path: `/m/${QUIZ_IDS.MT_HP}`,
    Component: MtHp,
  },
  {
    path: `/m/${QUIZ_IDS.MT}`,
    Component: Mt,
  },
  {
    path: `/m/${QUIZ_IDS.BR_NT}`,
    Component: BrNt,
  },
  {
    path: `/m/${QUIZ_IDS.FF_1M}`,
    Component: Ff1m,
  },
  {
    path: `/m/${QUIZ_IDS.MT_CS}`,
    Component: MtCs,
  },
  {
    path: `/m/${QUIZ_IDS.THREE_IN_ONE_NT}`,
    Component: ThreeInOneNt,
  },
];

export default FUNNEL_ROUTES;
